import React from 'react';
import { observer } from 'mobx-react';
import { FieldState } from 'formstate';
import { Radio, FormControlLabel, RadioGroup, Checkbox } from '@material-ui/core';
import { CoApplicantForm, AddressForm } from '../../forms/application-information-forms';
import * as Styles from './application-information-page.less';
import { Applicant } from './applicant';
import { Address } from './address';
import { CitizenshipInformation } from './citizenship-information';

interface IPrimaryApplicantProps {
    coApplicant: CoApplicantForm;
    hasCoApplicant: FieldState<boolean>;
    primaryAddress: AddressForm;
    states: string[];
    validate: (fieldState?: FieldState<string>) => () => Promise<void>;
}

export const CoApplicant: React.FC<IPrimaryApplicantProps> = observer(
    ({ coApplicant, hasCoApplicant, primaryAddress, validate, states }) => {
        const {
            $: {
                PersonalInfo: personalInfo,
                Document: document,
                HomeAddress: homeAddress,
                SameAsPrimaryAddress: sameAsPrimaryAddress,
            },
        } = coApplicant;

        return (
            <>
                <div className={Styles.sectionTitle}>Co-Applicant? *</div>
                <div className={Styles.row}>
                    <div className={Styles.shortCol}>
                        <RadioGroup
                            row
                            value={hasCoApplicant.value.toString()}
                            onChange={(e, val) => hasCoApplicant.onChange(JSON.parse(val))}
                        >
                            <FormControlLabel
                                className={Styles.radioLabel}
                                value="true"
                                control={<Radio className={Styles.radio} />}
                                label="Yes"
                                onClick={async (e) => {
                                    await validate()();
                                }}
                            />
                            <FormControlLabel
                                className={Styles.radioLabel}
                                value="false"
                                control={<Radio className={Styles.radio} />}
                                label="No"
                                onClick={async (e) => {
                                    await validate()();
                                }}
                            />
                        </RadioGroup>
                    </div>
                </div>
                {hasCoApplicant.value && (
                    <>
                        <Applicant
                            personalInfo={personalInfo}
                            document={document}
                            states={states}
                            validate={validate}
                        />
                        <div className={Styles.row}>
                            <div className={Styles.col}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            className={Styles.radio}
                                            checked={sameAsPrimaryAddress.value}
                                            onChange={async (e) => {
                                                sameAsPrimaryAddress.onChange(e.target.checked);
                                                await validate()();
                                            }}
                                        />
                                    }
                                    label="Address is the same as applicant"
                                />
                            </div>
                        </div>
                        <Address
                            address={
                                sameAsPrimaryAddress.value
                                    ? primaryAddress
                                    : coApplicant.$.HomeAddress
                            }
                            states={states}
                            disabled={sameAsPrimaryAddress.value}
                            validate={validate}
                        />
                        <CitizenshipInformation personalInfo={coApplicant.$.PersonalInfo} />
                    </>
                )}
            </>
        );
    }
);
